/**
 * TaskNotificationListener.js
 *
 * Componente invisível. Monta dentro do BrowserRouter,
 * escuta Realtime e dispara push notifications.
 *
 * Só ativa quando existe sessão autenticada.
 * Em rotas públicas (/c/:link, /login), não faz nada.
 *
 * seller_id vem do AuthContext — dado já disponível globalmente,
 * sem chamada HTTP extra ao backend.
 *
 * Localização: src/components/TaskNotificationListener.js
 */

import { useAuth } from '../hooks/useAuth';
import { useTaskNotifications } from '../hooks/useTaskNotifications';

function TaskNotificationListener() {
  const { profile } = useAuth();
  const sellerId = profile?.seller_id || null;

  useTaskNotifications(sellerId);
  return null;
}

export default TaskNotificationListener;
